import { render, staticRenderFns } from "./TasksView.vue?vue&type=template&id=5d2e5f90&scoped=true"
import script from "./TasksView.vue?vue&type=script&lang=ts"
export * from "./TasksView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2e5f90",
  null
  
)

export default component.exports